import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectIsCallCenter = createSelector(
    (state: AppState) => state.isCallCenter,
    (isCallCenter) => isCallCenter,
);
